define('app/models/question',['app/setup'], function(takhfifan) {

  takhfifan.Question = Backbone.Model.extend({

    validation: {
      'form_key': {
        required: true,
        msg: i18n.t('system_error')
      },
      'content': {
        required: true,
        rangeLength: [6, 500],
        msg: i18n.t('question_missing')
      },
      'author_email': {
        pattern: 'email',
        required: function(value, attr, computedState) {
          return (!this.isLoggedIn && _.isEmpty(value));
        },
        msg: i18n.t('please_enter_valid_email')
      },
      'author_name': {
        required: function(value, attr, computedState) {
          return (!this.isLoggedIn && _.isEmpty(value));
        },
        msg: i18n.t('please_enter_your_name')
      },
      'author_phone_number': {
        required: function(value, attr, computedState) {
          return (!this.isLoggedIn && _.isEmpty(value));
        },
        msg: i18n.t('telephone_missing')
      },
      'author_phone_number': function (value, key, fields) {
        var pat = new RegExp(/(09)[123]\d+$/);
        if(!pat.test(value) && value.length != 0) {
          return i18n.t('telephone_invalid')
        }
        else if(value.length != 11) {
          return i18n.t('telephone_range')
        }
      },
      'product_id': {
        min: 1,
        msg: i18n.t('system_error')
      }
    },

    isLoggedIn : false,

    submit: function(url) {
      if (typeof url === 'undefined' || url === null) {
        return false;
      }

      var _this = this;

      $.post(url, this.toJSON(), function(data) {
        if (data.success) {
          _this.trigger('submit:success', data.message);
        }
        else {
          _this.trigger('submit:error', data.error);
        }
      }).fail(function(data){
        _this.trigger('submit:error', data.responseJSON.error);
      });
    },

    defaults: {
      product_id: null,
      content: '',
      is_private: false
    }

  });

});

